export var mapValueToProps = function mapValueToProps(value) {
  return {
    checked: !!value
  };
};